const Select = (($) => {

    const NAME = 'select';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        container: false,//'body',
        noneSelectedText: '...',

        actionsBox: false,
        countSelectedText(numSelected, numTotal) {
            return (numSelected === 1) ? "{0} item selected" : "{0} items selected";
        },
        deselectAllText: 'Deselect All',
        dropdownAlignRight: false,
        header: false,
        liveSearch: false,
        liveSearchPlaceholder: null,
        liveSearchStyle: 'contains',
        maxOptions: false,
        menuClass: null,
        selectedAllText: 'Select All',
        selectedTextFormat: 'values',
        showContent: true,
        showIcon: true,
        showSubtext: false,
        size: 'auto',
        style: 'btn-default',
        title: null,
        width: '100%'
    };
    const Selector = {
        SELECT: `.js-${NAME}`
    }

    class Select {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this.$element = $(element);

            this.$element.on('change', function () {
                const $select = $(this);

                if (!$select.closest('.dropdown-content').length) {
                    //$select.trigger('click'); // trigger reevaluation
                }
            });
            if (this._config.menuClass) {
                this.$element.on('show.bs.dropdown', function () {
                    $(this).find('.dropdown-menu').addClass(this._config.menuClass);
                });
            }
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Select(this, config);
                    $this.data(DATA_KEY, data).selectpicker(config);
                }
            });
        }
    }

    $.fn.selectpicker.defaults = {
        iconBase: '',
        tickIcon: 'fa fa-check'
    };
    $(() => Select._jQueryInterface.call($(Selector.SELECT)));
    $(document).ajaxStop(() => Select._jQueryInterface.call($(Selector.SELECT)));

    $(document).off('keydown.bs.select').on('keydown.bs.select', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role="listbox"], .bs-searchbox input', function (e) {
        let $this = $(this),
            $parent = $this.is('input') ? $this.parent().parent() : $this.parent(),
            selectpicker = $parent.data('this'),
            active = selectpicker.$newElement.hasClass('open');

        selectpicker.keydown.call(this, e);

        if (/(^9$)/.test(e.keyCode.toString(10))) {
            // when control was previously opened but now closed.
            if (active && !selectpicker.$newElement.hasClass('open')) {
                const selector = 'input:not([type=hidden],:hidden,:disabled),select:not(:disabled),button:not(disabled,.dropdown-toggle)';
                const controls = [...$(selector, $this.parents('.modal').length > 0 ? '.modal' : document)];

                const currentIndex = controls.findIndex((control) => control === selectpicker.$element[0]);

                if (controls[currentIndex + 1].tagName === 'SELECT') {
                    $(controls[currentIndex + 1]).data('selectpicker').$button.focus();
                }
                else {
                    controls[currentIndex + 1].focus();
                }
            }
        }
    });

    $.fn[NAME] = Select._jQueryInterface;
    $.fn[NAME].Constructor = Select;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Select._jQueryInterface;
    }

    return Select;
})(jQuery);